import { useContext, useEffect, useState } from 'react';
import AddBlack from '../../../Assets/PlusIcon/AddBlack.svg';
import { useDispatch } from 'react-redux';
import { setModal } from '../../../Features/inventoryManagementSlice';
import { InventoryAddProductFormContext } from '../../../Context/InventoryAddProductFormContext';
import Rupee from '../../../Assets/rupee.svg';
import DeleteRed from '../../../Assets/DeleteRed.svg';
import Info from '../../../Assets/Info.svg';
import { showToast } from '../../../Components/Toaster/Toaster';
// import { toCamelCase } from '../../../lib/utils/utils';
import Percent from '../../../Assets/Modals/Percent.svg';

function ProductVariants() {
    const dispatch = useDispatch();

    const {
        sizeVariants,
        setSizeVariants,
        colorVariants,
        setColorVariants
    } = useContext(InventoryAddProductFormContext);

    const [displaySizeVariantMRPTooltip, setDisplaySizeVariantMRPTooltip] = useState(false);
    const [sizeMrpTooltipVisible, setSizeMrpTooltipVisible] = useState(false);

    const [displaySizeVariantSPTooltip, setDisplaySizeVariantSPTooltip] = useState(false);
    const [sizeSpTooltipVisible, setSizeSpTooltipVisible] = useState(false);

    const [displayColorVariantTooltip, setDisplayColorVariantTooltip] = useState(false);
    const [colorTooltipVisible, setColorTooltipVisible] = useState(false);

    const handleAddVariantButton = () => {
        dispatch(setModal('select-variant-type'));
    }

    const handleAddSizeClick = () => {
        dispatch(setModal('size-variant-form'));
    }

    const handleAddColorClick = () => {
        dispatch(setModal('color-variant-form'));
    }

    const changeHandlerForSizeVariant = (e) => {
        const { value, name, id } = e.target;

        const variant = sizeVariants.find(v => v.id === id);
        const mrp = Number(variant?.mrp);
        const discount = Number(value);

        if (name === "sellingPrice") {
            // disallow manual changes
            showToast("Selling Price is auto-calculated and cannot be changed directly", "warning");
            return;
        }

        if (name === "mrp") {
            if (value && Number(value) < 0) {
                showToast("MRP can't be negative", "warning");
                return;
            }
        }

        if (name === "discount") {
            if (isNaN(mrp) || mrp <= 0) {
                showToast("Please enter MRP before Discount", "warning");
                return;
            }

            if (value && !isNaN(discount) && discount > 100) {
                showToast("Discount can't be greater than 100", "warning");
                return;
            }
        }

        setSizeVariants(prevVariants =>
            prevVariants.map(variant =>
                variant.id === id ? { ...variant, [name]: value } : variant
            )
        );
    };

    const changeHandlerForColorVariant = (e) => {
        const { value, name, id } = e.target;

        setColorVariants(prevVariants =>
            prevVariants.map(variant =>
                variant.id === id ? { ...variant, [name]: value } : variant
            )
        );
    }

    const handleDeleteSizeVariant = (variant) => {
        const filteredList = sizeVariants.filter(item => item.id !== variant.id);
        setSizeVariants(filteredList);
    }

    const handleDeleteColorVariant = (variant) => {
        const filteredList = colorVariants.filter(item => item.id !== variant.id);
        setColorVariants(filteredList);
    }

    useEffect(() => {
        if(displaySizeVariantMRPTooltip) {
            setSizeMrpTooltipVisible(true);
        } else {
            setSizeMrpTooltipVisible(false);
        }
    }, [displaySizeVariantMRPTooltip]);

    useEffect(() => {
        if(displaySizeVariantSPTooltip) {
            setSizeSpTooltipVisible(true);
        } else {
            setSizeSpTooltipVisible(false);
        }
    }, [displaySizeVariantSPTooltip]);

    useEffect(() => {
        if(displayColorVariantTooltip) {
            setColorTooltipVisible(true);
        } else {
            setColorTooltipVisible(false);
        }
    }, [displayColorVariantTooltip]);

    useEffect(() => {
        setSizeVariants(prevVariants =>
            prevVariants.map(variant => {
                if (variant.mrp && Number(variant.mrp) > 0) {
                    if (variant.discount && Number(variant.discount) > 0) {
                        const discountedPrice = variant.mrp - (variant.mrp * (variant.discount / 100));
                        return {
                            ...variant,
                            sellingPrice: Math.round(discountedPrice)
                        };
                    } else {
                        return {
                            ...variant,
                            sellingPrice: variant.mrp,
                            discount: variant.discount || ''
                        };
                    }
                } else {
                    return {
                        ...variant,
                        sellingPrice: '',
                        discount: ''
                    };
                }
            })
        );
    }, [sizeVariants.map(v => `${v.mrp}-${v.discount}`).join(',')]);

    useEffect(() => {
        setSizeVariants(prevVariants =>
            prevVariants.map(variant => {
                if (variant.mrp && Number(variant.mrp) > 0) {
                    if (variant.discount && Number(variant.discount) > 0) {
                        const discountedPrice = variant.mrp - (variant.mrp * (variant.discount / 100));
                        return {
                            ...variant,
                            sellingPrice: Math.round(discountedPrice)
                        };
                    } else {
                        return {
                            ...variant,
                            sellingPrice: variant.mrp,
                            discount: ''
                        };
                    }
                } else {
                    return {
                        ...variant,
                        sellingPrice: ''
                    };
                }
            })
        );
    }, [sizeVariants.map(v => v.discount).join(','), sizeVariants.map(v => v.mrp).join(',')]);

    return (
        <div className="flex flex-col gap-4 border border-[#EAEAEA] p-5 rounded-xl">
            <div className="flex items-center justify-between">
                <h1 className='font-semibold text-[18px] leading-[26px] select-none'>Other Product Variants</h1>

                <button onClick={handleAddVariantButton} className="flex items-center gap-1">
                    <div className="w-6 h-6 flex items-center justify-center">
                        <img src={AddBlack} alt="" />
                    </div>

                    <p className='font-semibold text-base text-primaryColor'>Add Variant</p>
                </button>
            </div>

            {
                (sizeVariants.filter(variant => !variant.primary).length === 0 && colorVariants.filter(variant => !variant.primary).length === 0) && 
                <div className="flex flex-col items-center gap-2 text-[#666666] select-none">
                    <h1 className='font-semibold text-lg'>No product variants are added yet</h1>

                    <p className='font-medium text-[16px] leading-7'>This feature allows you to define the available colors, size and their stock and price vairants</p>
                </div>
            }

            {
                sizeVariants.filter(variant => !variant.primary).length > 0 && 
                <div className="border border-[#EAEAEA] rounded-lg">
                    <div className="w-full bg-[#F5F5F5] flex rounded-tl-lg rounded-tr-lg">
                        <div className="w-[calc(100%-44px)] flex">
                            <div className="w-1/5 px-[10px] py-2 flex items-center">
                                <p className='font-semibold text-base text-[#121212] w-fit select-none'>Size</p>
                            </div>

                            <div className="w-1/4 px-[10px] py-2 flex items-center gap-[10px]">
                                <p className='font-semibold text-base text-[#121212] w-fit select-none'>MRP for each</p>

                                <div className="relative w-6 h-6 flex items-center justify-center">
                                    <img 
                                        className='cursor-pointer'
                                        src={Info} 
                                        alt="" 
                                        onMouseEnter={() => setDisplaySizeVariantMRPTooltip(true)} 
                                        onMouseLeave={() => setDisplaySizeVariantMRPTooltip(false)} 
                                    />

                                    {
                                        displaySizeVariantMRPTooltip && 
                                        <div className={`${sizeMrpTooltipVisible ? 'opacity-100 visible' : 'opacity-0 invisible'} transition-all delay-500 ease-in-out absolute z-10 top-6 left-[20%]`}>
                                            <div 
                                                className="
                                                    w-0 h-0 
                                                    border-l-[8px] border-l-transparent 
                                                    border-r-[8px] border-r-transparent 
                                                    border-b-[10px] border-b-[#000000]
                                                "
                                            ></div>
                                            <div className="relative right-1/2 w-[320px] p-3 bg-[#000000] rounded-lg">
                                                <p className='font-normal text-[12px] leading-5 text-[#FFFFFF]'>This is optional field. If different sizes have different MRPs, specify them here.</p>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>

                            <div className="w-[15%] px-[10px] py-2 flex items-center">
                                <p className='font-semibold text-base text-[#121212] w-fit select-none'>Discount</p>
                            </div>

                            <div className="w-2/5 px-[10px] py-2 flex items-center gap-[10px]">
                                <p className='font-semibold text-base text-[#121212] w-fit select-none'>Your Selling Price for each</p>

                                <div className="relative w-6 h-6 flex items-center justify-center">
                                    <img 
                                        className='cursor-pointer'
                                        src={Info} 
                                        alt="" 
                                        onMouseEnter={() => setDisplaySizeVariantSPTooltip(true)} 
                                        onMouseLeave={() => setDisplaySizeVariantSPTooltip(false)} 
                                    />

                                    {
                                        displaySizeVariantSPTooltip && 
                                        <div className={`${sizeSpTooltipVisible ? 'opacity-100 visible' : 'opacity-0 invisible'} transition-all delay-500 ease-in-out absolute z-20 top-6 left-[20%]`}>
                                            <div 
                                                className="
                                                    w-0 h-0 
                                                    border-l-[8px] border-l-transparent 
                                                    border-r-[8px] border-r-transparent 
                                                    border-b-[10px] border-b-[#000000]
                                                "
                                            ></div>
                                            <div className="relative right-1/2 w-[320px] p-3 bg-[#000000] rounded-lg">
                                                <p className='font-normal text-[12px] leading-5 text-[#FFFFFF]'>This is optional field. If different sizes have different Selling prices, specify them here.</p>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="w-11"></div>
                    </div>

                    {sizeVariants.filter(variant => !variant.primary).map(variant => {
                        return (
                            <div key={variant.id} className="w-full bg-[#FFFFFF] flex items-center border-t border-[#EAEAEA]">
                                <div className="w-[calc(100%-44px)] flex">
                                    <div className="w-1/5 px-[10px] py-[18px]">
                                        <p className='font-medium text-[14px] leading-6 text-[#121212] select-none'>{variant.size}</p>
                                    </div>

                                    <div className="w-1/4 px-[10px] py-[18px] flex items-center gap-1">
                                        <div className="w-6 h-6 flex items-center justify-center">
                                            <img src={Rupee} alt="" />
                                        </div>

                                        <input 
                                            className='w-[calc(100%-24px)] outline-none'
                                            type="number" 
                                            placeholder='Eg: 1999' 
                                            id={variant.id} 
                                            name='mrp' 
                                            value={variant.mrp || ''} 
                                            onChange={changeHandlerForSizeVariant} 
                                        />
                                    </div>

                                    <div className="w-[15%] px-[10px] py-[18px] flex items-center gap-1">
                                        <input 
                                            className='w-[calc(100%-24px)] outline-none'
                                            type="number" 
                                            placeholder='00' 
                                            id={variant.id} 
                                            name='discount' 
                                            value={variant.discount || ''} 
                                            onChange={changeHandlerForSizeVariant} 
                                        />

                                        <div className="w-6 h-6 flex items-center justify-center">
                                            <img src={Percent} alt="" />
                                        </div>
                                    </div>

                                    <div className="w-2/5 px-[10px] py-[18px] flex items-center gap-1">
                                        <div className="w-6 h-6 flex items-center justify-center">
                                            <img src={Rupee} alt="" />
                                        </div>

                                        <input 
                                            className='w-[calc(100%-24px)] outline-none'
                                            type="number" 
                                            placeholder='Eg: 1999' 
                                            id={variant.id} 
                                            name='sellingPrice' 
                                            value={variant.sellingPrice ?? ''} 
                                            onChange={changeHandlerForSizeVariant} 
                                        />
                                    </div>
                                </div>

                                <div className="w-11 h-11 flex items-center justify-center">
                                    <button onClick={() => handleDeleteSizeVariant(variant)} className="outline-none w-8 h-8 flex items-center justify-center">
                                        <img src={DeleteRed} alt="" />
                                    </button>
                                </div>
                            </div>
                        )
                    })}

                    <div className="px-[10px] py-[18px] border-t border-[#EAEAEA]">
                        <button onClick={handleAddSizeClick} className='w-fit font-semibold text-[14px] leading-6 text-primaryColor'>
                            + Add more
                        </button>
                    </div>
                </div>
            }

            {
                colorVariants.filter(variant => !variant.primary).length > 0 && 
                <div className="border border-[#EAEAEA] rounded-lg overflow-hidden">
                    <div className="w-full bg-[#F5F5F5] flex">
                        <div className="w-[calc(100%-44px)] flex">
                            <div className="w-1/2 px-[10px] py-2 flex items-center">
                                <p className='font-semibold text-base text-[#121212] w-fit'>Colours</p>
                            </div>
                            
                            <div className="w-1/2 px-[10px] py-2 flex items-center gap-[10px]">
                                <p className='font-semibold text-base text-[#121212] w-fit'>Product Name</p>

                                <div className="relative w-6 h-6 flex items-center justify-center">
                                    <img
                                        className='cursor-pointer'
                                        src={Info} 
                                        alt="" 
                                        onMouseEnter={() => setDisplayColorVariantTooltip(true)} 
                                        onMouseLeave={() => setDisplayColorVariantTooltip(false)} 
                                    />

                                    {
                                        displayColorVariantTooltip && 
                                        <div className={`${colorTooltipVisible ? 'opacity-100 visible' : 'opacity-0 invisible'} transition-all delay-500 ease-in-out absolute z-20 top-6 left-[20%]`}>
                                            <div 
                                                className="
                                                    w-0 h-0 
                                                    border-l-[8px] border-l-transparent 
                                                    border-r-[8px] border-r-transparent 
                                                    border-b-[10px] border-b-[#000000]
                                                "
                                            ></div>
                                            <div className="relative right-1/2 w-[320px] p-3 bg-[#000000] rounded-lg">
                                                <p className='font-normal text-[12px] leading-5 text-[#FFFFFF]'>This is optional field. To set this color as the main product, enter the product name.</p>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="w-11"></div>
                    </div>

                    {colorVariants.filter(variant => !variant.primary).map(variant => {
                        return (
                            <div key={variant.id} className="w-full bg-[#FFFFFF] flex items-center border-t border-[#EAEAEA]">
                                <div className="w-[calc(100%-44px)] flex">
                                    <div className="w-1/2 px-[10px] py-[18px]">
                                        <p className='font-medium text-[14px] leading-6 text-[#121212] select-none'>{variant.color}</p>
                                    </div>

                                    <input 
                                        className='w-1/2 outline-none'
                                        type="text" 
                                        placeholder='Eg: Blue Long sleeve shirt' 
                                        id={variant.id} 
                                        name='variantName' 
                                        value={variant.variantName || ''} 
                                        onChange={changeHandlerForColorVariant} 
                                    />
                                </div>

                                <div className="w-11 h-11 flex items-center justify-center">
                                    <button onClick={() => handleDeleteColorVariant(variant)} className="outline-none w-8 h-8 flex items-center justify-center">
                                        <img src={DeleteRed} alt="" />
                                    </button>
                                </div>
                            </div>
                        )
                    })}

                    <div className="px-[10px] py-[18px] border-t border-[#EAEAEA]">
                        <button onClick={handleAddColorClick} className='w-fit font-semibold text-[14px] leading-6 text-primaryColor'>
                            + Add more
                        </button>
                    </div>
                </div>
            }
        </div>
    );
}

export default ProductVariants;
